import { NgModule } from '@angular/core';
import { ChipsInputFormFieldComponent } from './chips-input-form-field.component';
import {  MatFormFieldModule } from '@angular/material/form-field';
import {  MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import {  MatButtonModule } from '@angular/material/button';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {  MatTooltipModule } from '@angular/material/tooltip';
import {  MatInputModule } from '@angular/material/input';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        MatFormFieldModule,
        MatChipsModule,
        CommonModule,
        MatButtonModule,
        MatAutocompleteModule,
        ScrollingModule,
        MatTooltipModule,
        MatInputModule,
        FontAwesomeModule,
    ],
    declarations: [ChipsInputFormFieldComponent],
    exports: [ChipsInputFormFieldComponent],
})
export class ChipsInputFormFieldModule {}
